// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2aCNM","OrderButton":"BuildControls_OrderButton__2tEg7","enable":"BuildControls_enable__33TNe"};